import React from 'react';
import { AppButton, Box, Inscription, Preloader, RoundCloseIcon } from '@common-fe/common-fe';

import { CloseActionCardType } from '@/modules/transaction/Cards/Cards.types';
import theme from '@/styles/theme';

import { CardStatusActionWrap } from '../ChangeStatusCardModal.styles';

import CardActionCardHeader from './CardActionCardHeader';

const CLOSE_CARD_TEXT = 'Close Card';
const CLOSE_CARD_WARNING = 'You cannot reopen this card after closing it';

interface CardCloseActionCardProps {
  loadingButton: boolean;
  onOpenCloseConfirmationModal: () => void;
  displayType: CloseActionCardType;
}

const CardCloseActionCard: React.FC<CardCloseActionCardProps> = ({
  loadingButton,
  onOpenCloseConfirmationModal,
  displayType,
}) => {
  const isSecondary = displayType === CloseActionCardType.SECONDARY;

  return (
    <CardStatusActionWrap
      width={isSecondary ? '100%' : undefined}
      height={isSecondary ? '96px' : undefined}
      padding={isSecondary ? theme.spacings.l : undefined}
      background="canvas"
      round="container1Round"
      justify={isSecondary ? 'between' : undefined}
      border={{ color: 'border2', size: 'small' }}
    >
      {
        displayType === CloseActionCardType.PRIMARY ? (
          <>
            <CardActionCardHeader
              icon={<RoundCloseIcon color="danger" size="44px" />}
              title={CLOSE_CARD_TEXT}
              description={(
                <>
                  You cannot reopen this card
                  <br />
                  after closing it.
                </>
              )}
            />
            <AppButton
              testId="card-close-action-card_button"
              buttonType="primary"
              color="red"
              width="100%"
              style={{ height: '40px', paddingInline: '12px', border: 'none' }}
              disabled={loadingButton}
              onClick={onOpenCloseConfirmationModal}
            >
              {loadingButton ? (
                <Box width="100%" align="center">
                  <Preloader color="white" />
                </Box>
              ) : (
                CLOSE_CARD_TEXT
              )}
            </AppButton>
          </>
        ) : (
          <Box direction="row" justify="between" align="center">
            <Box direction="row" align="end">
              <RoundCloseIcon color="danger" size="44px" />
              <Box justify="center" margin={{ left: 'm' }}>
                <Inscription color="textBody" weight="bold" lineHeight="20px" margin={{ bottom: 'xxxs' }}>
                  {CLOSE_CARD_TEXT}
                </Inscription>
                <Inscription color="textBody" lineHeight="20px">
                  {CLOSE_CARD_WARNING}
                </Inscription>
              </Box>
            </Box>
            <AppButton
              testId="card-close-action-card_button"
              buttonType="primary"
              color="red"
              width="210px"
              style={{ height: '40px', paddingInline: '12px', border: 'none' }}
              disabled={loadingButton}
              onClick={onOpenCloseConfirmationModal}
            >
              {loadingButton ? (
                <Box width="100%" align="center">
                  <Preloader color="white" />
                </Box>
              ) : (
                CLOSE_CARD_TEXT
              )}
            </AppButton>
          </Box>
        )
      }
    </CardStatusActionWrap>
  );
};

export default CardCloseActionCard;
